var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"min-h-screen grid grid-cols-1 gap-1 place-items-center"},[_c('Loading')],1):_c('div',[_c('MenuList',{attrs:{"menuMergedItems":_vm.$store.getters.menuMergedItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }